var map = {
	"./alberto-garcia.jpg": 6658,
	"./antonio-delaoliva.jpg": 4650,
	"./dani-requejo.png": 7055,
	"./fernando.png": 1469,
	"./jesus-gil.jpg": 7122,
	"./juan-carlos.png": 4190,
	"./mads-pedersen.jpg": 588,
	"./manuel-gil.jpg": 2146
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6385;